import angular, { isNumber } from "angular";

import "../../../services/user";
import "../../../services/countries";
import * as dawaAutocomplete from "dawa-autocomplete2";
import { showDarAddressModal } from "../../../helpers/darAddressModal";

angular.module("folkeuni").component("editUser", {
  templateUrl: "/shop-dist/templates/user-edit.html",
  transclude: false,
  bindings: {
    siteId: "@",
  },
  controller: function (User, Countries, $scope, $element, $timeout) {
    var $ctrl = this;
    $ctrl.currentUser = null;
    $ctrl.user = null;
    $ctrl.countries = [];

    $ctrl.$onInit = function () {
      $ctrl.countries = Countries.getAll;

      User.getCurrent().then(
        function (userObj) {
          userObj.siteId = $ctrl.siteId;

          let countryCode = userObj.country;
          if (countryCode && countryCode.indexOf(":") > 0) {
            countryCode = countryCode.split(":")[0];
          }

          const foundCountry = $ctrl.countries.find(
            (c) => c.code === countryCode
          );

          userObj.country = foundCountry ? foundCountry.code : "DK";

          $ctrl.user = userObj;
          $ctrl.currentUser = angular.copy(userObj);
        },
        function (errorResponse) {
          $ctrl.status = {
            success: false,
            message:
              "Der skete en fejl, forsøg venligst igen. Hvis du stadig ikke lykkedes må du meget gerne kontakte os.",
          };
          console.log("Error", errorResponse);
        }
      );

      $timeout(function () {
        var streetnameInput = $element[0].querySelector("#dawa-address");
        if (streetnameInput) {
          dawaAutocomplete.dawaAutocomplete(streetnameInput, {
            select: function (selected) {
              $scope.$apply(function () {
                $ctrl.user.streetNumber = selected.data.husnr;
                $ctrl.user.streetName = selected.data.vejnavn;
                $ctrl.user.postalCode = Number(selected.data.postnr);
                $ctrl.user.city = selected.data.postnrnavn;
                $ctrl.user.floorNumber = selected.data.etage;
                if (
                  selected.data.dør != null &&
                  !isNaN(Number(selected.data.dør))
                ) {
                  $ctrl.user.roomNumber =
                    selected.data.dør != undefined
                      ? selected.data.dør.toString()
                      : null;
                  $ctrl.user.side = null;
                } else {
                  $ctrl.user.side =
                    selected.data.dør != undefined && selected.data.dør != null
                      ? selected.data.dør.toString()
                      : null;
                  $ctrl.user.roomNumber = null;
                }
              });
            },
          });
        }
      }, 0);
    };

    $ctrl.updateUser = function () {
      $ctrl.showLoadingOverlay = true;

      var newUser = Object.assign({}, $ctrl.user);

      if (isNumber($ctrl.user.phoneNumber)) {
        newUser.phoneNumber = $ctrl.user.phoneNumber.toString();
      }

      if ($ctrl.user.employee) {
        newUser.employee.cpr = $ctrl.user.employee.cpr
          ? $ctrl.user.employee.cpr.replace("-", "")
          : null;

          newUser.employee.phoneNumber2 = $ctrl.user.phoneNumber;
      }

      const validateModel = {
        siteId: Number($ctrl.siteId),
        email: newUser.email,
        password: newUser.password,
        firstName: newUser.firstName,
        middleName: newUser.middleName || null,
        lastName: newUser.lastName,
        phoneNumber: newUser.phoneNumber,
        streetName: newUser.streetName,
        streetNumber: newUser.streetNumber,
        floorNumber: newUser.floorNumber || null,
        side: newUser.side || null,
        roomNumber: newUser.roomNumber || null,
        postalCode: Number(newUser.postalCode),
        city: newUser.city,
        country: newUser.country,
        password: "",
      };

      User.validate(validateModel).then(
        async function (successResponse) {
          if (successResponse.isValidAddress) {
            internalUpdateUser(newUser);
          } else {
            $ctrl.showLoadingOverlay = false;
            showAddressModal(successResponse.suggestedAddress, newUser);
          }
        },
        function (errorResponse) {
          $ctrl.status = {
            success: false,
            message:
              "Der skete en fejl, forsøg venligst igen. Hvis du stadig ikke lykkedes må du meget gerne kontakte os.",
          };
          console.log("error", errorResponse);
        }
      );
    };

    function internalUpdateUser(userObj) {
      $ctrl.showLoadingOverlay = true;
      User.update(userObj).then(
        function (updateResponse) {
          $ctrl.status = {
            success: true,
            message: "Din bruger er nu blevet opdateret.",
          };

          $timeout(function () {
            $ctrl.status = null;
          }, 5000);

          $ctrl.showLoadingOverlay = false;
        },
        function (errorResponse) {
          $ctrl.status = {
            success: false,
            message:
              "Der skete en fejl, forsøg venligst igen. Hvis du stadig ikke lykkedes må du meget gerne kontakte os.",
          };
          console.log("error", errorResponse);
        }
      );
    }

    function showAddressModal(suggestedAddress, userObj) {
      showDarAddressModal(suggestedAddress, [
        {
          label: "Behold min adresse",
          classes: "contained danger",
          click: (modal) => {
            modal.closeModal();
            internalUpdateUser(userObj);
          },
        },
        {
          label: "Ret adressen",
          classes: "contained secondary",
          click: (modal) => {
            modal.closeModal();
          },
        },
        {
          label: "Brug DAR-adresse",
          classes: "contained primary",
          click: (modal) => {
            const c = userObj;
            c.streetName = suggestedAddress.streetName;
            c.streetNumber = suggestedAddress.streetNumber;
            c.floorNumber = suggestedAddress.floorNumber || null;
            c.side = suggestedAddress.side || null;
            c.roomNumber = suggestedAddress.roomNumber || null;
            c.postalCode = suggestedAddress.postalCode;
            c.city = suggestedAddress.city;
            modal.closeModal();
            internalUpdateUser(userObj);
          },
        },
      ]);
    }

    // Validation

    $ctrl.comparePasswords = function () {
      compare(
        $scope.customerInfo.confirmPassword,
        $ctrl.user.confirmPassword,
        $ctrl.user.password
      );
    };

    function compare(input, value1, value2) {
      if (input && input != "") {
        if (value1 != value2) {
          input.$setValidity("match", false);
          if (input && input.$setTouched) input.$setTouched();
        } else {
          input.$setValidity("match", true);
          if (input && input.$setTouched) input.$setTouched();
        }
      }
    }

    var emailExistsTimeout;
    $ctrl.asyncEmailCheckInProgress = false;
    $ctrl.emailExistsError = false;
    $ctrl.checkEmailExists = function () {
      if (!$ctrl.user) {
        $ctrl.emailExistsError = false;
        $scope.customerInfo.email.$setValidity("emailexists", true);
        return;
      }
      var email = $ctrl.user.email;
      if (email == $ctrl.currentUser.email) {
        $ctrl.emailExistsError = false;
        $scope.customerInfo.email.$setValidity("emailexists", true);
        $scope.customerInfo.email.$setTouched();
        return; // Hvis email ikke er ændret, så spring checket over
      }
      if (!email || !$ctrl.patterns.email.test(email)) {
        $ctrl.emailExistsError = false;
        $scope.customerInfo.email.$setValidity("emailexists", true);
        return;
      }
      if (emailExistsTimeout) $timeout.cancel(emailExistsTimeout);
      $ctrl.asyncEmailCheckInProgress = true;
      emailExistsTimeout = $timeout(function () {
        User.exists(window.platform.departmentId, email).then(
          function () {
            $ctrl.asyncEmailCheckInProgress = false;

            $ctrl.emailExistsError = false;
            $scope.customerInfo.email.$setValidity("emailexists", true);
          },
          function (err) {
            $ctrl.asyncEmailCheckInProgress = false;
            // Hvis API'et returnerer 409, så eksisterer brugeren
            if (err && err.status === 409) {
              $ctrl.emailExistsError = true;
              $scope.customerInfo.email.$setValidity("emailexists", false);
              $scope.customerInfo.email.$setTouched();
            } else {
              // Ved andre fejl antag at email ikke findes
              $ctrl.emailExistsError = false;
              $scope.customerInfo.email.$setValidity("emailexists", true);
            }
          }
        );
      }, 400);
    };

    $ctrl.validateCpr = function () {
      var cpr = $ctrl.user.employee.cpr;
      if (!cpr) {
        $scope.customerInfo.employeeCpr.$setValidity("cprInvalid", true);
        $scope.customerInfo.email.$setTouched();
        return;
      }

      var unchangedMatch = cpr.match(/^\d{6}XXXX/);
      if (unchangedMatch) {
        $scope.customerInfo.employeeCpr.$setValidity("cprInvalid", false);
        return;
      }

      var match = cpr.match(/^(\d\d)(\d\d)(\d\d)(\d)(\d)(\d)(\d)$/);
      if (!match) {
        $scope.customerInfo.employeeCpr.$setValidity("cprInvalid", true);
        $scope.customerInfo.email.$setTouched();
        return;
      }

      var day = parseInt(match[1], 10);
      var month = parseInt(match[2], 10);
      var year = parseInt(match[3], 10);
      var c7 = parseInt(match[4], 10);

      if ([0, 1, 2, 3].includes(c7)) {
        year = 1900 + year;
      } else if (c7 === 4) {
        year = year >= 0 && year <= 36 ? 2000 + year : 1900 + year;
      } else if ([5, 6, 7, 8].includes(c7)) {
        year = year >= 0 && year <= 57 ? 2000 + year : 1800 + year;
      } else if (c7 === 9) {
        year = year >= 0 && year <= 36 ? 2000 + year : 1900 + year;
      }

      var date = new Date(year, month - 1, day);
      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      ) {
        $scope.customerInfo.employeeCpr.$setValidity("cprInvalid", false);
        return;
      }

      $scope.customerInfo.employeeCpr.$setValidity("cprInvalid", true);
      $scope.customerInfo.email.$setTouched();
    };

    $ctrl.patterns = {
      firstName: /^[A-Za-zÆØÅæøå .'-]{1,25}$/,
      middleName: /^[A-Za-zÆØÅæøå .'-]{1,25}$/,
      lastName: /^[A-Za-zÆØÅæøå .'-]{1,25}$/,
      streetName: /^[A-Za-zÆØÅæøå0-9 .'-]{2,50}$/,
      phoneNumber: /^\+?[0-9]{8,30}$/,
      streetNumber: /^[0-9\w .]{1,10}$/,
      floorNumber: /^[\w.]{1,3}$/,
      roomNumber: /^[A-Za-zÆØÅæøå0-9 .'-]{1,10}$/,
      side: /^[\w .]{1,4}$/,
      city: /^[A-Za-zÆØÅæøå .'-]{2,30}$/,
      email: /^[a-z0-9.+_-]+@([a-z0-9æøå-]+\.)+[a-z]{2,}$/,
    };
  },
});
